import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { findIndex, filter, find, result } from 'lodash';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { Logger } from '@app/core';
import {
  ProcesoSecundario,
  Const,
  BaseControl,
  ConfirmComponent,
  Categoria,
  ProcesoBase,
  TramiteBase,
} from '@app/shared';
import { ProcessAutomationService } from '../shared';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/Subscription';
import { ManageSecondaryDetailDataService } from './shared/manage-secondary-detail.data.service';
import { ManageSecondaryDetailFormService } from './shared/manage-secondary-detail.form.service';
import { ManageSecondaryDetailConfigService } from './shared/manage-secondary-detail.config.service';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { Subject } from 'rxjs';
import { LocalDataSource } from 'ng2-smart-table';

const log = new Logger('ManageSecondaryCompletionsComponent');

export interface InfoStages {
  id: number;
  etapa: string;
  etapa_id: number;
  tiempo: number;
  porcentaje_alerta: number;
  dias_habiles: boolean;
  update: boolean;
  delete: boolean;
  review: boolean;
}

@Component({
  selector: 'iw-manage-secondary-detail',
  templateUrl: './manage-secondary-detail.component.html',
  styleUrls: ['./manage-secondary-detail.component.scss'],
  providers: [
    ProcessAutomationService,
    ManageSecondaryDetailDataService,
    ManageSecondaryDetailFormService,
    HelperFlowService
  ]
})

export class ManageSecondaryDetailComponent implements OnInit, OnDestroy {

  // Controla la entrada de las secundarias al componente
  @Input()
  set secondary (s: ProcesoSecundario) {
    this._secondary = s;
    this.loadTableData();
  }
  // Todas las categorias
  categories: Categoria[];
  // Todos los procesos de la categoria
  processes: ProcesoBase[];
  // Todos los tramites(default) del proceso
  tramites: TramiteBase[];
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
   // Define cuando mostrar la tabla principal o el formulario
   formOpen = false;
   // Define cuando mostrar la tabla Ver detalles de la etapa
   formViewOpen = false;
   // Define los tipos de permisos que tiene el usuario en sesión
   activateAction = {
     created: false,
     review: false,
     update: false,
     delete: false,
   };
   // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Tramite seleccionado
  detailPocedure: any;
  // Contiene las finalizaciones de la secundaria
  private _secondary: ProcesoSecundario;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
   // Referencia al componente de confirmación
   @ViewChild('confirm') private confirm: ConfirmComponent;
   // Referencia a la plantilla para el control personalizado de ng-select
   @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
   // Referencia al control de cateogria
   @ViewChild("categoriaControl") ngCategoriaControl: TemplateRef<any>;
  // Referencia al control de proceso
  @ViewChild("procesoControl") ngProcesoControl: TemplateRef<any>;
  // Referencia al control de tramite
  @ViewChild("tramiteControl") ngTramiteControl: TemplateRef<any>;


  constructor(
    private toastr: ToastrService,
    private mscds: ManageSecondaryDetailDataService,
    private mscfs: ManageSecondaryDetailFormService,
  ) {
  }

  ngOnInit() {
    const configTable = new ManageSecondaryDetailConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get secondary(): ProcesoSecundario {
    return this._secondary;
  }

  loadTableData(){
    if(this.secondary.id){
      this.mscds
      .getDetail(this.secondary.id)
      .subscribe(data => {
        this.sourceData = new LocalDataSource(data);
      });
    }
  }

   /**
   * Controla las diferentes acciones de agregar, modificar o eliminar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManageSecondaryDetailComponent
   */
   defineActionCondictions(action: string, data?: any) {
    switch (action.toString()) {
     case 'add':
         this.formOpen = true;
         this.actionForm = 'Agregar';
         this.mscds
          .getCategories(false)
          .subscribe(data => {
            this.categories = data;
            this.controls = this.mscfs.getFormTramit(
              {
                ngSelect: this.ngSelectTpl,
                categoriaTmpl: this.ngCategoriaControl,
                procesoTmpl: this.ngProcesoControl,
                tramiteTmpl: this.ngTramiteControl
              }
            );
          });
         break;
     case 'delete':
         this.detailPocedure = data;
         this.question = '¿Realmente desea eliminar el trámite?';
         this.confirm.open();
       break;
   }
 }
/**
   * Evento que se ejecuta al seleccionar una categoría.
   * - Consulta los procesos de una categoria.
   *
   * @memberof SelectTramiteComponent
   */
selectedCategory(category:any) {
  if (category) {
    this.mscds
      .getProcess(category.id, false)
      .subscribe(data => {
        this.processes = data;
      });
  }
  this.tramites = [];
  this.processes = [];
}

/**
 * Evento que se ejecuta al seleccionar un proceso.
 * - Consulta los trámites por default asociados a un proceso.
 *
 * @memberof SelectTramiteComponent
 */
selectedProcess(process:any) {
  this.tramites = [];
  if (process) {
    this.mscds
      .getDefaultTrtamites(process.id, false)
      .subscribe(data => {
        this.tramites = data;
      });
  }
}

/**
   * Guarda el detalle de documento
   *
   * @param {*} data
   * @memberof TypeDocumentaryComponent
   */
sended(data: any) {
  let detalle = {
    tramite: data.tramite,
    secundaria: this.secondary.id
  };
  this.mscds.addDetail(detalle).then((res) => {
      if (res) {
        this.loadTableData();
        this.formOpen = false;
      }
    });
}

/**
   * Controla la respuesta de confirmacion
   *
   * @param {boolean} resp
   * @memberof ManageSecondaryCompletionsComponent
   */
actionComfirm(resp: boolean) {
  if (resp) {
    this.mscds.deleteDetail(this.detailPocedure.id).then((res) => {
      if (res) {
        this.loadTableData();
      }
    });
    }
  }

 /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof TramitStagesComponent
   */
 closeFormTramit() {
  this.actionForm = '';
  this.question = '';
  this.formOpen = false;
  this.detailPocedure = null;
}

  
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-detail/manage-secondary-detail.component.ts